// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-sidebar .img-logo{
   width: 175px;
   height: 75px;
  
   padding-left: 55px;
}

.main-sidebar .nav-sidebar .menu-is-opening > .nav-link i.right {
   transform: rotate(90deg);
}

/* === Reset semua tombol biar selaras dengan link === */
.nav-sidebar button.nav-link {
  background: none;
  border: none;
  outline: none;
  box-shadow: none;
  width: 100%;
  text-align: left;
  padding: 8px 16px;
  color: #333;
  font-weight: normal;
  border-radius: 4px;
}

/* Hilangkan hover aneh pada button */
.nav-sidebar button.nav-link:hover {
  background-color: rgba(46, 93, 154, 0.1);
  color: #2E5D9A;
}

/* Biar icon & teks sejajar */
.nav-sidebar .nav-link i.nav-icon {
  margin-right: 8px;
}

/* Konsisten dengan link biasa */
.nav-sidebar .nav-link {
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: none;
  font-size: 14px;
}

/* Hover semua item sama */
.nav-sidebar .nav-link:hover {
  background-color: rgba(46, 93, 154, 0.1);
  color: #2E5D9A;
}

/* Aktif (halaman sedang dibuka) */
.nav-sidebar .nav-link.active {
  background-color: #2E5D9A !important;
  color: #fff !important;
  border-radius: 6px;
}

/* Parent aktif (punya child aktif) */
.nav-sidebar .nav-link.active-parent {
  background-color: rgba(46, 93, 154, 0.1);
  color: #2E5D9A;
  font-weight: 600;
}

/* Hapus bullet list */
.nav-sidebar .nav-item {
  list-style: none;
}
`, "",{"version":3,"sources":["webpack://./src/component/layouts/navbar.css"],"names":[],"mappings":"AAAA;GACG,YAAY;GACZ,YAAY;;GAEZ,kBAAkB;AACrB;;AAEA;GACG,wBAAwB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,wCAAwC;EACxC,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB","sourcesContent":[".main-sidebar .img-logo{\r\n   width: 175px;\r\n   height: 75px;\r\n  \r\n   padding-left: 55px;\r\n}\r\n\r\n.main-sidebar .nav-sidebar .menu-is-opening > .nav-link i.right {\r\n   transform: rotate(90deg);\r\n}\r\n\r\n/* === Reset semua tombol biar selaras dengan link === */\r\n.nav-sidebar button.nav-link {\r\n  background: none;\r\n  border: none;\r\n  outline: none;\r\n  box-shadow: none;\r\n  width: 100%;\r\n  text-align: left;\r\n  padding: 8px 16px;\r\n  color: #333;\r\n  font-weight: normal;\r\n  border-radius: 4px;\r\n}\r\n\r\n/* Hilangkan hover aneh pada button */\r\n.nav-sidebar button.nav-link:hover {\r\n  background-color: rgba(46, 93, 154, 0.1);\r\n  color: #2E5D9A;\r\n}\r\n\r\n/* Biar icon & teks sejajar */\r\n.nav-sidebar .nav-link i.nav-icon {\r\n  margin-right: 8px;\r\n}\r\n\r\n/* Konsisten dengan link biasa */\r\n.nav-sidebar .nav-link {\r\n  color: #333;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  border: none;\r\n  background: none;\r\n  font-size: 14px;\r\n}\r\n\r\n/* Hover semua item sama */\r\n.nav-sidebar .nav-link:hover {\r\n  background-color: rgba(46, 93, 154, 0.1);\r\n  color: #2E5D9A;\r\n}\r\n\r\n/* Aktif (halaman sedang dibuka) */\r\n.nav-sidebar .nav-link.active {\r\n  background-color: #2E5D9A !important;\r\n  color: #fff !important;\r\n  border-radius: 6px;\r\n}\r\n\r\n/* Parent aktif (punya child aktif) */\r\n.nav-sidebar .nav-link.active-parent {\r\n  background-color: rgba(46, 93, 154, 0.1);\r\n  color: #2E5D9A;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Hapus bullet list */\r\n.nav-sidebar .nav-item {\r\n  list-style: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
